import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNotifications } from './NotificationsProvider';

export default function DevicePushStatus() {
  const { t } = useTranslation();
  const { deviceStatus, refreshDeviceStatus, enablePush, openPushSettings } = useNotifications();
  const [busy, setBusy] = useState(false), [failed, setFailed] = useState(false);
  useEffect(() => { void refreshDeviceStatus?.(); }, [refreshDeviceStatus]);
  if (!deviceStatus) return null;
  const { platform, permission, registration, available } = deviceStatus;
  const key = platform === 'web' ? 'deviceBrowser' : !available ? 'deviceUnavailable'
    : permission === 'denied' ? (platform === 'ios' ? 'permissionDeniedIOS' : 'permissionDeniedAndroid')
      : permission === 'prompt' ? 'devicePrompt' : permission !== 'granted' ? 'deviceUnknown'
        : registration === 'registered' ? 'deviceRegistered' : registration === 'registering' ? 'deviceRegistering' : 'deviceUnregistered';
  const settings = available && permission === 'denied' && ['ios', 'android'].includes(platform);
  const retry = available && permission !== 'denied' && registration !== 'registered' && registration !== 'registering';
  const action = async () => {
    setBusy(true); setFailed(false);
    try { await (settings ? openPushSettings() : enablePush()); }
    catch { setFailed(true); }
    finally { setBusy(false); }
  };
  return <div className="settings-push-status" role="status" aria-live="polite">
    {available && permission === 'granted' && <p>{t('notifications:deviceAllowed')}</p>}
    <p>{t(`notifications:${key}`)}</p>
    {failed && <p>{t('notifications:registrationFailed')}</p>}
    {(settings || retry) && <button type="button" onClick={action} disabled={busy}>
      {t(`notifications:${settings ? 'openDeviceSettings' : 'connectDevice'}`)}
    </button>}
  </div>;
}
